import React, { createContext, useState, useContext, PropsWithChildren } from 'react'
import { UserProfileModal } from './UserProfileModal'


export interface UserProfileModalContextProps {
    openUserProfile: (userId: number) => void
    closeUserProfile: () => void
}

export const UserProfileContext = createContext<UserProfileModalContextProps>({
    openUserProfile: (userId: number) => {
        //
    },
    closeUserProfile: () => {
        //
    }
})

export const UserProfileModalContextProvider: React.FC<PropsWithChildren> = ({
    children
}) => {

    const [visible, setVisible] = useState(false)
    const [userId, setUserId] = useState(0)

    const openUserProfile = (userId: number) => {
        setUserId(userId)
        setVisible(true)
    }

    const closeUserProfile = () => {
        setVisible(false)
    }

    const reset = () => {
        setUserId(0)
    }

    return (
        <UserProfileContext.Provider value={{ openUserProfile, closeUserProfile }}>
            {children}
            <UserProfileModal
                visible={visible}
                onClose={() => setVisible(false)}
                onCloseDone={reset}
                userId={userId}
            />
        </UserProfileContext.Provider>
    )
}

export const UserProfileConsumer = UserProfileContext.Consumer

export const useUserProfile = () => {
    return useContext(UserProfileContext)
}
